(() => {
  'use strict';
  const root = document.querySelector('[data-hairecover-page]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const sticky = document.querySelector('.hc-sticky[data-sticky-buy]');
  const infoDialog = document.querySelector('.hc-dialog[data-info-dialog]');
  const cartDialog = document.querySelector('.hc-dialog[data-cart-dialog]');
  const owned = [root, sticky, infoDialog, cartDialog].filter(Boolean);
  const all = selector => [...new Set(owned.flatMap(el => [...el.querySelectorAll(selector)]))];
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  let infoTrigger;
  let cartTrigger;

  [infoDialog, cartDialog].filter(Boolean).forEach(dialog => {
    dialog.querySelectorAll('[data-close-dialog]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
  });
  infoDialog?.addEventListener('close', () => infoTrigger?.focus({preventScroll:true}));
  cartDialog?.addEventListener('close', () => cartTrigger?.focus({preventScroll:true}));
  root.querySelectorAll('[data-open-info]').forEach(button => button.addEventListener('click', () => {
    const template = document.getElementById(button.dataset.openInfo);
    const destination = infoDialog?.querySelector('[data-dialog-content]');
    if (!template?.content || !destination) return;
    infoTrigger = button;
    destination.replaceChildren(template.content.cloneNode(true));
    if (!infoDialog.open) infoDialog.showModal();
  }));

  const slides = [...root.querySelectorAll('[data-media-slide]')];
  const thumbs = [...root.querySelectorAll('[data-media-thumb]')];
  const gallery = root.querySelector('[data-gallery]');
  const mediaCount = root.querySelector('[data-media-count]');
  let slideIndex = 0;
  function showSlide(index, reveal = false) {
    if (!slides.length) return;
    slideIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      slide.hidden = i !== slideIndex;
      slide.querySelectorAll('video').forEach(video => { if (i !== slideIndex) video.pause(); });
    });
    thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === slideIndex)));
    gallery?.classList.toggle('is-video', Boolean(slides[slideIndex].querySelector('video')));
    if (mediaCount) mediaCount.textContent = `${slideIndex + 1} / ${slides.length}`;
    // Scroll only the thumbnail strip. scrollIntoView also moves the whole page.
    const active = thumbs[slideIndex];
    const strip = active?.parentElement;
    if (reveal && strip && strip.scrollWidth > strip.clientWidth) {
      const itemBox = active.getBoundingClientRect();
      const stripBox = strip.getBoundingClientRect();
      const offset = itemBox.left < stripBox.left ? itemBox.left - stripBox.left : itemBox.right > stripBox.right ? itemBox.right - stripBox.right : 0;
      if (offset) strip.scrollBy({left:offset, behavior:motion()});
    }
  }
  thumbs.forEach((button, i) => button.addEventListener('click', () => showSlide(i, true)));
  root.querySelector('[data-media-prev]')?.addEventListener('click', () => showSlide(slideIndex - 1, true));
  root.querySelector('[data-media-next]')?.addEventListener('click', () => showSlide(slideIndex + 1, true));
  gallery?.addEventListener('keydown', event => {
    if (event.target.closest('video, input, select, textarea') || event.altKey || event.ctrlKey || event.metaKey) return;
    const destinations = {ArrowRight:slideIndex + 1, ArrowLeft:slideIndex - 1, Home:0, End:slides.length - 1};
    if (!(event.key in destinations)) return;
    event.preventDefault();
    showSlide(destinations[event.key], true);
    if (event.target.matches('[data-media-thumb]')) thumbs[slideIndex]?.focus({preventScroll:true});
  });
  showSlide(0);

  root.querySelectorAll('[data-carousel]').forEach(carousel => {
    const track = carousel.querySelector('[data-track]');
    const counter = carousel.querySelector('[data-position]');
    const previous = carousel.querySelector('[data-prev]');
    const next = carousel.querySelector('[data-next]');
    if (!track?.children.length) return;
    const step = () => track.children[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
    const update = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const position = Math.max(0, Math.min(max, track.scrollLeft));
      const width = step();
      if (counter) counter.textContent = `${Math.min(track.children.length, Math.round(position / (width || 1)) + 1)} / ${track.children.length}`;
      if (previous) previous.disabled = position < 2;
      if (next) next.disabled = position >= max - 2;
    };
    previous?.addEventListener('click', () => track.scrollBy({left:-step(), behavior:motion()}));
    next?.addEventListener('click', () => track.scrollBy({left:step(), behavior:motion()}));
    track.addEventListener('scroll', update, {passive:true});
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    else window.addEventListener('resize', update, {passive:true});
    update();
  });

  const form = root.querySelector('[data-product-form]');
  if (!form) return;
  let config;
  try { config = JSON.parse(root.querySelector('[data-product-config]')?.textContent || '{}'); }
  catch (_) { return; } // Keep the native Shopify form working if configuration is unavailable.
  if (!Array.isArray(config.variants) || !config.variants.length) return;
  const status = root.querySelector('[data-form-status]');
  const buttons = all('[data-add-button]');
  let submitting = false;
  const formatter = new Intl.NumberFormat(config.locale || 'en-US', {style:'currency', currency:config.currency || 'USD'});
  const money = cents => formatter.format(Number(cents) / 100);
  const selectedVariant = () => config.variants.find(variant => String(variant.id) === String(new FormData(form).get('id')));
  const selectedLabel = variant => form.querySelector('input[name="id"]:checked')?.dataset.label || form.querySelector('select[name="id"] option:checked')?.textContent || variant.title || config.title || 'Your selected item';
  const announce = message => { if (status) status.textContent = message; };
  function syncButtons() {
    const available = selectedVariant()?.available;
    buttons.forEach(button => {
      button.disabled = submitting || !available;
      if (submitting) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
      const label = button.querySelector('[data-button-label]');
      if (label) label.textContent = submitting ? 'Adding…' : available ? 'Add to cart' : 'Currently unavailable';
    });
  }
  function updateVariant() {
    const variant = selectedVariant();
    syncButtons();
    if (!variant) return;
    all('[data-selected-price]').forEach(el => { el.textContent = money(variant.price); });
    all('[data-selected-name]').forEach(el => { el.textContent = selectedLabel(variant); });
    const url = new URL(location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState(history.state, '', url);
    announce('');
  }
  const requested = new URLSearchParams(location.search).get('variant');
  const inputs = [...form.querySelectorAll('input[name="id"]')];
  const matching = inputs.find(input => input.value === requested);
  if (matching && matching.type === 'radio') matching.checked = true;
  const select = form.querySelector('select[name="id"]');
  if (select && [...select.options].some(option => option.value === requested)) select.value = requested;
  inputs.forEach(input => {
    const variant = config.variants.find(item => String(item.id) === input.value);
    input.closest('.hc-offer')?.querySelectorAll('[data-variant-price]').forEach(el => { if (variant) el.textContent = money(variant.price); });
  });
  form.addEventListener('change', event => { if (event.target.name === 'id') updateVariant(); });
  updateVariant();

  if (sticky) {
    sticky.inert = true;
    sticky.setAttribute('aria-hidden', 'true');
    const primaryButton = form.querySelector('[data-add-button]');
    if (primaryButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        const entry = entries[0];
        const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', visible);
        sticky.inert = !visible;
        sticky.setAttribute('aria-hidden', String(!visible));
      }, {threshold:0}).observe(primaryButton);
    }
    sticky.querySelector('[data-add-button]')?.addEventListener('click', event => {
      event.preventDefault();
      if (!submitting) form.requestSubmit();
    });
  }
  form.addEventListener('submit', async event => {
    event.preventDefault();
    const variant = selectedVariant();
    if (submitting || !variant?.available) return;
    const addedLabel = selectedLabel(variant);
    cartTrigger = document.activeElement;
    submitting = true;
    syncButtons();
    announce('');
    try {
      if (config.previewOnly) {
        announce('Preview: your selected item is ready. Checkout is available on the live store.');
        return;
      }
      const cartAddUrl = config.cartAddUrl || `${window.Shopify?.routes?.root || '/'}cart/add.js`;
      const items = [{id:variant.id, quantity:1}];
      if (Array.isArray(config.gifts) && config.gifts.length && String(variant.id) === String(config.giftFor)) {
        let have = {};
        try {
          const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {credentials:'same-origin'})).json();
          (cart.items || []).forEach(item => { if (item.properties && item.properties._gift) have[item.variant_id] = true; });
        } catch (e) {}
        config.gifts.forEach(id => { if (!have[id]) items.push({id, quantity:1, properties:{_gift:'Pod'}}); });
      }
      await window.hcAddToCart(items);
      announce(`${addedLabel} added to your cart.`);
    } catch (error) {
      announce(error.message || 'Please check your connection and try again.');
      if (status) { status.tabIndex = -1; status.focus({preventScroll:true}); status.scrollIntoView({block:'nearest', behavior:motion()}); }
    } finally {
      submitting = false;
      syncButtons();
    }
  });
})();
